package com.example.mystybag.communication

data class MystyBagSDKConfig(
    val isProduction: Boolean = true,
    /** API key for https://api.companybook.bg (header `X-API-Key`). Required for merchant BULSTAT lookup. */
    val companyBookApiKey: String = "",
)